import script from "./ConferenceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceComponent.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceComponent.vue?vue&type=style&index=0&id=1fcae5c0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcae5c0"]])

export default __exports__